/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Rule_Sets_Custom_Property_NameInputs */

const en_tables_rule_sets_custom_property_name = /** @type {(inputs: Tables_Rule_Sets_Custom_Property_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

const de_tables_rule_sets_custom_property_name = /** @type {(inputs: Tables_Rule_Sets_Custom_Property_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

/**
* | output |
* | --- |
* | "Name" |
*
* @param {Tables_Rule_Sets_Custom_Property_NameInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_rule_sets_custom_property_name = /** @type {((inputs?: Tables_Rule_Sets_Custom_Property_NameInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Rule_Sets_Custom_Property_NameInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_rule_sets_custom_property_name(inputs)
	return de_tables_rule_sets_custom_property_name(inputs)
});